import { z } from "zod";
export const DEFAULT_PAGE_SIZE = 50;
export const MAX_PAGE_SIZE = 200;
/** Cursor tabanlı sayfalama sorgu parametreleri (AGENTS.md §6). Cursor istemci için opak bir dizgedir. */
export const pageQuerySchema = z.object({
    cursor: z.string().max(1000).optional().describe("Önceki yanıttaki nextCursor değeri"),
    limit: z.coerce.number().int().min(1).max(MAX_PAGE_SIZE).default(DEFAULT_PAGE_SIZE),
});
export const pageInfoSchema = z.object({
    nextCursor: z.string().nullable().describe("Sonraki sayfa yoksa null"),
    hasMore: z.boolean(),
});
export function pageOf(item) {
    return z.object({ items: z.array(item), page: pageInfoSchema });
}
//# sourceMappingURL=pagination.js.map